import { metricStore } from "hooks/useMetricDefined";
import { getPrimaryUnitKey } from "utils/functions";

const findAppSensor = (device: any) => {
    // Handle both lowercase 'app' and uppercase 'APP' for backward compatibility
    const appArray = device.app || device.APP;
    return appArray?.find((d: any) => {
        // Handle both APPID and appId field names
        const dAppId = d.APPID || d.appId;
        return dAppId === device.appId;
    });
};

const resolveSymbolToUnitName = (device: any, appSensor: any) => {
    // If unit is a symbol (e.g., "V"), find the actual unit name (e.g., "Voltage")
    if (!device.unit || !appSensor.UNITS) return undefined;
    return appSensor.UNITS.find((unitKey: string) => {
        return appSensor[unitKey]?.SYMBOL === device.unit;
    });
};

const speltOutPrimaryUnitForApp = (device: any) => {
    if (device.unit === "BINARY" || !device.unit) return [""];

    const appSensor = findAppSensor(device);
    if (!appSensor) return device.unit?.toLowerCase();

    const unitName = resolveSymbolToUnitName(device, appSensor);
    if (unitName) return unitName.toLowerCase();

    return getPrimaryUnitKey(appSensor);
};

const speltOutPrimaryUnitWithoutApp = (device: any) => {
    if (device.unit) {
        return typeof device.unit === "string"
            ? device.unit.toLowerCase()
            : device.unit;
    }
    return device.units || "";
};

const speltOutPrimaryUnit = (device: any) => {
    if (device.app || device.APP) {
        return speltOutPrimaryUnitForApp(device);
    }
    return speltOutPrimaryUnitWithoutApp(device);
};

export const getMQTTQueryByDevice = (device: any) => {
    return metricStore
        .getState()
        .getMQTTQuery(device.cls, device.appId, speltOutPrimaryUnit(device));
};